<template>
  <div class="flex justify-center flex-wrap p2" v-if="!loading">
    <div class="col-12 pb2 flex justify-center"> 
      <div class="col-10 md-col-3"> 
        <Datepicker v-model="date" range :format="formatCalendarDate" @update:modelValue="searchByDate" :clearable="true" />
      </div>
    </div>

    <div v-if="data && data.length" v-for="option in data" class="col-12 md-col-8 mx1 lg-mx3">
       
          <div v-if="!['credit', 'recharge'].includes(option.type)" v-for="product in option.productList" class="col-12 flex p1 mt2 white-bg">

             <div style="border:solid; border-radius:50%; width: 60px;height: 60px;" class="col-2 flex justify-center items-center"> 
              <!-- TODO MISSING ICON BASE ON PRODUCT TYPE -->
              <i class="icon-food" style="font-size:30px;"></i>
             </div>

            <div class="col-6 flex flex-column justify-start pl2 ">
              <h4 class="h4n m0"> {{product.name}} </h4>
              <span class="dark-grey">{{format(new Date(option.date * 1000), 'dd/MM/yyyy')}}</span> 
            </div> 

            <div class="col-5 flex justify-end items-center"> 
              <span class="h5n">  - {{product.price}} EUR </span>
            </div> 
          </div> 

          <div v-else class="col-12 flex p1 mt2 white-bg">
             <div style="border:solid; border-radius:50%; width: 60px;height: 60px;" class="col-2 flex justify-center items-center"> 
              <i class="icon-deposit-euro pb1" style="font-size:50px;"></i>
             </div>

            <div class="col-8 flex flex-column justify-start pl2 ">
              <h3 class="h3n m0"> {{getReferencelabel(option.type === 'recharge' ? 'CREDIT_PAYMENT' : 'REFUND')}} </h3>
              <span class="dark-grey">{{format(new Date(option.date * 1000), 'dd/MM/yyyy')}}</span> 
            </div> 

            <div class="col-3 flex justify-end items-center"> 
              <span class="h5n">  {{option.type === 'recharge' ? '+' : '-' }} {{option.total}} EUR </span>
            </div>
          </div> 


    </div>
    <div v-else> 
      <h2> {{getReferencelabel('ANY_EXPENSE')}} </h2> 
    </div>

  </div>
</template>
<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import { getReferencelabel } from '@/mixins/utils';
import { getWalletsPaymentHistory } from '@/mixins/requests';
const { format } = require('date-fns');

export default {
  components: { Datepicker },
  setup() {
    const date = ref([])
    const route = useRoute();
    const store = useStore();
    const loading = ref(true)
    
    const data = ref([])

    async function getHistoryData () {

      const startDate = date.value && date.value[0] ? format(new Date(date.value[0]), 't') : 1435741343
      const endDate = date.value && date.value[1] ? format(new Date(date.value[1]), 't') : 2224746143

      store.commit('setLoading', true);
      const response = await getWalletsPaymentHistory(route.params.id, startDate, endDate)
      data.value = response.factureData
      loading.value = false
      store.commit('setLoading', false);
    }


    const searchByDate = () => {
        getHistoryData()
    }

    const formatCalendarDate = (date) => {
      const dateFormat = date ? format(new Date(date[0]), 'dd/MM/yyyy') : null

      return  date && date[1] ? `${dateFormat} - ${format(new Date(date[1]), 'dd/MM/yyyy')}` : dateFormat
    }

   onMounted(async () => {
      // const endDate = new Date();
      // const startDate = new Date(new Date().setDate(endDate.getDate() - 7));
      // date.value = [startDate, endDate];
      await getHistoryData()    
    });

    return {data, date, formatCalendarDate , searchByDate, getReferencelabel, format, loading}
  },
}
</script>
<style >
  .dp__button{ 
    display: none;
  }
  .dp__selection_preview{
    display: none;
  }
</style>
